// extracted by mini-css-extract-plugin
export default {"overlay":"DragToCreateOutline-module__overlay___OrgTp","popover":"DragToCreateOutline-module__popover___smz0g"};